import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

export default function NotFound() {
    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />
            <section style={{ maxWidth: 900, margin: "0 auto", padding: "100px 24px", textAlign: "center" }}>
                <div style={{ fontSize: 120, fontWeight: 800, color: "#E5E7EB", letterSpacing: "-0.05em" }}>
                    404
                </div>
                <h1 style={{ fontSize: 40, fontWeight: 800, marginBottom: 16 }}>Page not found</h1>
                <p style={{ fontSize: 20, color: "#6B7280", marginBottom: 40 }}>
                    The page you're looking for doesn't exist.
                </p>
                <Link to="/" style={{
                    background: "#2563EB", color: "white",
                    padding: "16px 28px", borderRadius: 12,
                    textDecoration: "none", fontWeight: 700, fontSize: 17,
                }}>
                    Back to Home
                </Link>
            </section>
            <Footer />
        </div>
    )
}
